var _path, _path2, _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgAuctionMobile = function SvgAuctionMobile(props) {
  var _id7 = useUniqueInlineId();
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 57,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id7, ")")
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 38,
    r: 28,
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 38,
    r: 35,
    fill: "url(#".concat(_id2, ")"),
    opacity: 0.2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.468 38.888h-2.8v2.828h-1.554v-2.828h-2.786v-1.47h2.786v-2.842h1.554v2.842h2.8v1.47Zm4.274.756c0 .401-.09.803-.266 1.204a3.313 3.313 0 0 1-.798 1.12h4.998v1.274h-6.552l-.196-.826c.438-.42.76-.835.966-1.246.214-.42.322-.92.322-1.498 0-.186-.033-.424-.098-.714h-1.652v-1.092h1.302c-.131-.41-.234-.78-.308-1.106a4.825 4.825 0 0 1-.112-1.05c0-.57.126-1.069.378-1.498a2.62 2.62 0 0 1 1.092-.994c.466-.243 1.003-.364 1.61-.364.98 0 1.75.276 2.31.826.56.55.882 1.27.966 2.156H30.22c-.047-.494-.224-.896-.532-1.204-.308-.308-.71-.462-1.204-.462-.467 0-.85.15-1.148.448-.3.29-.448.71-.448 1.26 0 .29.037.579.112.868.084.29.205.663.364 1.12h2.534v1.092h-2.226c.046.252.07.48.07.686Zm4.808-4.83v-1.498h3.164V43.2h-1.68v-8.386H32.55Zm4.84 3.374c0 1.578.28 2.814.84 3.71.56.887 1.492 1.33 2.8 1.33 1.306 0 2.24-.448 2.8-1.344.56-.896.84-2.128.84-3.696 0-1.559-.28-2.781-.84-3.668-.56-.896-1.494-1.344-2.8-1.344-1.308 0-2.24.444-2.8 1.33-.56.887-.84 2.114-.84 3.682Zm5.683 0c0 1.139-.14 2.011-.42 2.618-.28.607-.821.91-1.624.91-.812 0-1.358-.303-1.638-.91-.28-.606-.42-1.48-.42-2.618 0-1.13.14-1.992.42-2.59.28-.597.826-.896 1.638-.896.803 0 1.344.303 1.624.91.28.597.42 1.456.42 2.576Zm3.039 0c0 1.578.28 2.814.84 3.71.56.887 1.493 1.33 2.8 1.33 1.306 0 2.24-.448 2.8-1.344.56-.896.84-2.128.84-3.696 0-1.559-.28-2.781-.84-3.668-.56-.896-1.493-1.344-2.8-1.344-1.307 0-2.24.444-2.8 1.33-.56.887-.84 2.114-.84 3.682Zm5.684 0c0 1.139-.14 2.011-.42 2.618-.28.607-.822.91-1.624.91-.812 0-1.358-.303-1.638-.91-.28-.606-.42-1.48-.42-2.618 0-1.13.14-1.992.42-2.59.28-.597.826-.896 1.638-.896.802 0 1.344.303 1.624.91.28.597.42 1.456.42 2.576Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 67.5,
    r: 33.2,
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 67.5,
    r: 41.5,
    fill: "url(#".concat(_id4, ")"),
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 40,
    r: 32,
    fill: "url(#".concat(_id5, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 40,
    r: 40,
    fill: "url(#".concat(_id6, ")"),
    opacity: 0.2
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M245.523 40.872h-3.2v3.232h-1.776v-3.232h-3.184v-1.68h3.184v-3.248h1.776v3.248h3.2v1.68Zm4.885.864c0 .459-.102.917-.304 1.376a3.786 3.786 0 0 1-.912 1.28h5.712v1.456h-7.488l-.224-.944c.501-.48.869-.955 1.104-1.424.245-.48.368-1.05.368-1.712 0-.214-.038-.486-.112-.816h-1.888v-1.248h1.488c-.15-.47-.267-.89-.352-1.264a5.476 5.476 0 0 1-.128-1.2c0-.65.144-1.221.432-1.712.298-.49.714-.87 1.248-1.136.533-.278 1.146-.416 1.84-.416 1.12 0 2 .315 2.64.944.64.63 1.008 1.45 1.104 2.464h-1.696c-.054-.566-.256-1.024-.608-1.376-.352-.352-.811-.528-1.376-.528-.534 0-.971.17-1.312.512-.342.33-.512.81-.512 1.44 0 .33.042.661.128.992.096.33.234.757.416 1.28h2.896v1.248h-2.544c.053.288.08.55.08.784Zm10.087-7.584c.747 0 1.387.133 1.92.4.534.256.934.613 1.2 1.072.278.459.416.97.416 1.536 0 .715-.202 1.312-.608 1.792-.394.47-.954.752-1.68.848v.08c.779.224 1.387.56 1.824 1.008.448.437.672 1.045.672 1.824 0 .95-.314 1.722-.944 2.32-.629.587-1.53.88-2.704.88-1.205 0-2.176-.304-2.912-.912-.736-.619-1.157-1.53-1.264-2.736h1.808c.064.64.294 1.152.688 1.536.395.373.928.56 1.6.56.63 0 1.11-.166 1.44-.496.342-.33.512-.758.512-1.28 0-.63-.245-1.11-.736-1.44-.48-.33-1.178-.496-2.096-.496h-.432v-1.504h.432c1.739.021 2.608-.57 2.608-1.776 0-.523-.16-.934-.48-1.232-.32-.299-.757-.448-1.312-.448-.554 0-1.018.17-1.392.512-.373.33-.597.816-.672 1.456h-1.792c.075-1.11.448-1.968 1.12-2.576.672-.619 1.6-.928 2.784-.928Zm5.532 5.92c0 1.802.32 3.216.96 4.24.64 1.013 1.707 1.52 3.2 1.52 1.494 0 2.56-.512 3.2-1.536.64-1.024.96-2.432.96-4.224 0-1.782-.32-3.179-.96-4.192-.64-1.024-1.706-1.536-3.2-1.536-1.493 0-2.56.506-3.2 1.52-.64 1.013-.96 2.416-.96 4.208Zm6.496 0c0 1.301-.16 2.298-.48 2.992-.32.693-.938 1.04-1.856 1.04-.928 0-1.552-.347-1.872-1.04-.32-.694-.48-1.69-.48-2.992 0-1.29.16-2.278.48-2.96.32-.683.944-1.024 1.872-1.024.918 0 1.536.346 1.856 1.04.32.682.48 1.664.48 2.944Zm3.473 0c0 1.802.32 3.216.96 4.24.64 1.013 1.707 1.52 3.2 1.52s2.56-.512 3.2-1.536c.64-1.024.96-2.432.96-4.224 0-1.782-.32-3.179-.96-4.192-.64-1.024-1.707-1.536-3.2-1.536s-2.56.506-3.2 1.52c-.64 1.013-.96 2.416-.96 4.208Zm6.496 0c0 1.301-.16 2.298-.48 2.992-.32.693-.939 1.04-1.856 1.04-.928 0-1.552-.347-1.872-1.04-.32-.694-.48-1.69-.48-2.992 0-1.29.16-2.278.48-2.96.32-.683.944-1.024 1.872-1.024.917 0 1.536.346 1.856 1.04.32.682.48 1.664.48 2.944Z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 7,
    x2: 63,
    y1: 38,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 0,
    x2: 70,
    y1: 38,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 131.3,
    x2: 197.7,
    y1: 67.5,
    y2: 67.5,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 123,
    x2: 206,
    y1: 67.5,
    y2: 67.5,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 229,
    x2: 293,
    y1: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 221,
    x2: 301,
    y1: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h301v57H0z"
  })))));
};
export default SvgAuctionMobile;